<script setup lang="ts">
import { useRenderStore } from '@/builder/stores/renderStore';
import { computed, ref, watch, onMounted } from 'vue';
import ErrorItem from './ErrorItem.vue';

const renderStore = useRenderStore();

// refs
const showErrorContainer = ref(false);

// computed
const toasts = computed(() => renderStore.toasts);

// methods
const beforeEnter = (el) => {
    el.style.height = '0';
};

const enter = (el) => {
    el.style.height = el.scrollHeight + 'px';
};

const beforeLeave = (el) => {
    el.style.height = el.scrollHeight + 'px';
}

const leave = (el) => {
    el.style.height = '0';
}

const removeErrors = () => {
    renderStore.clearAllToasts();
};

// watchers
watch(toasts, (newToasts) => {
    showErrorContainer.value = newToasts.length > 0;
}, { deep: true });
</script>

<template>
    <Transition appear @before-enter="beforeEnter" @enter="enter" @before-leave="beforeLeave" @leave="leave">
        <section v-if="showErrorContainer" class="rd-overflow-hidden error-notification-shade slide-down" role="alert"
            aria-live="assertive" aria-atomic="true">
            <div id="errorContainer" class="shade-content rd-items-center rd-flex rd-justify-between">
                <div class="rd-items-start rd-flex rd-justify-between rd-w-full">
                    <div class="rd-flex rd-mr-5 rd-mt-2.5">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"
                            class="alert-icon">
                            <path
                                d="M12.8659 3.00017L22.3922 19.5002C22.6684 19.9785 22.5045 20.5901 22.0262 20.8662C21.8742 20.954 21.7017 21.0002 21.5262 21.0002H2.47363C1.92135 21.0002 1.47363 20.5525 1.47363 20.0002C1.47363 19.8246 1.51984 19.6522 1.60761 19.5002L11.1339 3.00017C11.41 2.52187 12.0216 2.358 12.4999 2.63414C12.6519 2.72191 12.7782 2.84815 12.8659 3.00017ZM10.9999 16.0002V18.0002H12.9999V16.0002H10.9999ZM10.9999 9.00017V14.0002H12.9999V9.00017H10.9999Z">
                            </path>
                        </svg>
                        <ul v-for="toast in toasts" :key="toast.id">
                            <ErrorItem :id="toast.id" :text="toast.text" :duration="toast.duration"
                                :class="{ 'rd-mt-2.5': toasts.length > 1 }" />
                        </ul>
                    </div>

                    <button type="button" class="close-error-message">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"
                            @click="removeErrors">
                            <path
                                d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z">
                            </path>
                        </svg>
                        <span class="sr-only">Close error message</span>
                    </button>
                </div>
            </div>
        </section>
    </Transition>
</template>
